import { Map } from 'immutable';

import * as Actions from '../actions';
import * as AppConstants from '../constants';
import { getInDomain } from '../domains/externalUtils';
import { getStore } from '../store/StoreAccessor';
import { getBranchInstance } from '../tools/Globals';

import { getAllAnnotations } from './EntityUtils';
import { getGenreByPandoraId, getPlaylistFromState } from './MusicUtils';

export function openBranchErrorToast() {
  const { dispatch } = getStore();
  const coachmarkMessageProps = {
    ...AppConstants.DesktopApp.messages.branchError,
    values: {},
    messageName: AppConstants.DesktopApp.desktopErrorCodes.ERROR_CREATING_BRANCH_LINK,
  };
  dispatch(Actions.UseCases.openErrorToast(coachmarkMessageProps));
}

export function generateBranchLink({ deepLinkData }) {
  return new Promise(resolve => {
    const branch = getBranchInstance();
    branch.link({ data: deepLinkData }, (error, link) => {
      resolve({ error, link });
    });
  });
}

export function getSourcePath(state, resourceId, resourceType) {
  const allAnnotations = getAllAnnotations(state);
  const emptyMap = Map();
  if (resourceType === AppConstants.SourceTypes.PandoraTypes.PLAYLIST) {
    const playlist = getPlaylistFromState(state, resourceId) || emptyMap;
    return playlist.get('shareableUrlPath');
  } else if (resourceType === AppConstants.SourceTypes.PandoraTypes.STATION) {
    let station;
    const isGenreStation = getInDomain('playback.utils.isGenrePandoraId')(resourceId);
    if (isGenreStation) {
      station = getGenreByPandoraId(state, resourceId) || allAnnotations.get(resourceId);
    } else {
      station =
        getInDomain('playback.utils.getStationByStationId')(state, resourceId) ||
        allAnnotations.get(resourceId);
    }
    // If stationId is a pandoraId (SF), share seedId backstage page
    if (station) {
      if (getInDomain('playback.utils.isStationPandoraId')(resourceId)) {
        return station.get('shareableUrlPath');
      } else if (isGenreStation) {
        return station.get('shareableUrlPath') || `/genre/${station.get('token')}`;
      }
    }
    return `/station/play/${resourceId}`;
  }
  const entityData = allAnnotations.get(resourceId, emptyMap);
  return entityData.get('shareableUrlPath');
}
